var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row flex justify-between align-end"},[_c('div',{staticClass:"flex align-end"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"items flex align-end"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }